import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'app/hooks';
import { unwrapResult } from '@reduxjs/toolkit';
import {
  convertToMediaFile,
  message,
} from 'app/pages/request-single-page/components-v4';
import {
  getPublicId,
  getPublicRequestData,
} from 'app/pages/request-single-page/selectors';
import { getPublicRequestAttachments } from 'app/pages/request-single-page/request-single-page-slice';
import { useFilesState } from './use-files-state';
import { useFilesUpload } from './use-file-upload';

export const useFiles = () => {
  const dispatch = useAppDispatch();
  const publicId = useSelector(getPublicId);
  const requestData = useSelector(getPublicRequestData);

  const {
    committedFiles,
    setCommittedFiles,
    draftFiles,
    setDraftFiles,
    commitFiles,
    discardDraft,
    dialogOpen,
    handleDraftChange,
  } = useFilesState();
  const uploader = useFilesUpload();

  const getAttachments = useCallback(async () => {
    try {
      const files = await dispatch(getPublicRequestAttachments(publicId)).then(
        unwrapResult
      );

      const converted = convertToMediaFile(files);
      setCommittedFiles(converted);
    } catch {
      message({ type: 'error', text: 'Не удалось загрузить файлы' });
    }
  }, [dispatch, publicId, setCommittedFiles]);

  useEffect(() => {
    if (!requestData.request_number) {
      return;
    }

    getAttachments();
  }, [getAttachments, requestData.request_number]);

  const handleCommit = async () => {
    if (!draftFiles.length) {
      return;
    }

    const { succeeded } = await uploader.upload(draftFiles);

    if (succeeded.length) {
      commitFiles(succeeded);
    } else {
      discardDraft();
    }
  };

  return {
    committedFiles,
    setCommittedFiles,
    draftFiles,
    setDraftFiles,
    dialogOpen,
    handleDraftChange,
    handleDiscard: discardDraft,
    handleCommit,
    uploadStatus: uploader.status,
  };
};
